module.exports = __webpack_public_path__ + "static/media/customizationIcon.ee4fd12d.svg";